<mat-form-field appearance="outline">
    <mat-label>{{ field[CONSTANTS.name] }}</mat-label>
    <mat-select 
            [value]="selectedValue" 
            (selectionChange)="onFieldChange($event, field)"
            required="{{ field.required }}">
        <!-- Search functionality -->
        <mat-option>
            <ngx-mat-select-search 
                [formControl]="selectFilterCtrl"
                placeholderLabel="{{ 'fields.searchInList' | translate }}" 
                noEntriesFoundLabel="{{ 'fields.noListResults' | translate }}"
                disableInitialFocus="true"
                hideClearSearchButton="true">
            </ngx-mat-select-search>
        </mat-option>
        
        <mat-option [value]="null">
            {{ 'fields.uniquechoicelist.novalue' | translate }}
        </mat-option>
        <ng-container *ngFor="let elem of filteredList">
            <mat-option *ngIf="!userFilter || filterElement(elem)" [value]="elem.element_id" [disabled]="field.ancestry.length != elem.depth">
                <span [ngClass]="'depth-'+elem.depth">{{ elem[CONSTANTS.name] }}</span>
            </mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>